<div class="app-content filter">
    <div class="filter-header">
        <h2>Filter</h2>
        <div (click)="close()">
            <app-custom-icon
                [iconPath]="'assets/icons/general-icons.svg'"
                [imageName]="'icon-close'">
            </app-custom-icon>
        </div>
    </div>
    <mat-accordion>
        @if (filterForm | formControl:'title'; as control) {
            <app-sidebar-filter-panel
                [title]="'Form Title'"
                [controls]="[control]"
                [isEmpty]="!control.value">
                <app-input
                    [control]="control"
                    [height]="40"
                    [placeholder]="'Search by Form Title'"></app-input>
            </app-sidebar-filter-panel>
        }

        @if (filterForm | formControl:'type'; as control) {
            <app-sidebar-filter-panel
                [title]="'Report Type'"
                [controls]="[control]"
                [isEmpty]="!control.value.length">
                <div class="checkbox-list">
                    @for (status of typeList; track status.value) {
                        <app-checkbox
                            [view]="'button'"
                            [label]="status.label"
                            [checked]="control.value | formControlContainsOption:status.value"
                            (checkedChanged)="setCheckboxValue(control, $event, status.value)"></app-checkbox>
                    }
                </div>
            </app-sidebar-filter-panel>
        }

        @if (filterForm | formControl:'industries'; as control) {
            <app-sidebar-filter-panel
                [title]="'Industry'"
                [controls]="[control]"
                [isEmpty]="!control.value.length">
                <div class="checkbox-list">
                    @for (industry of industryList; track industry.value) {
                        <app-checkbox
                            [view]="'button'"
                            [label]="industry.label"
                            [checked]="control.value | formControlContainsOption:industry.value"
                            (checkedChanged)="setCheckboxValue(control, $event, industry.value)"></app-checkbox>
                    }
                </div>
            </app-sidebar-filter-panel>
        }

        @if (filterForm | formControl:'owner'; as control) {
            <app-sidebar-filter-panel
                [title]="'Owner'"
                [controls]="[control]"
                [isEmpty]="!control.value">
                <app-radio-list
                    [options]="ownerList"
                    [view]="'button-view'"
                    [direction]="'list-column'"
                    [currentSelection]="control.value"
                    (onChange)="control.setValue($event)"></app-radio-list>
            </app-sidebar-filter-panel>
        }
    </mat-accordion>
</div>
